import { Pipe, PipeTransform } from '@angular/core';

import { TravelerService } from '@fcom/dapi/interfaces';

@Pipe({
  name: 'finAddedServices',
  standalone: false,
})
export class AddedServicesPipe implements PipeTransform {
  transform(services?: TravelerService[]): TravelerService[] {
    return services?.filter((service) => service.quantity > 0 && !service.paid && !service.ticketed) ?? [];
  }
}
